const config = {
  accountsUrl: process.env.VUE_APP_ACCOUNTS_URL,
  authUrl: process.env.VUE_APP_AUTH_URL,
  billingUrl: process.env.VUE_APP_BILLING_URL,
  consoleV2Url: process.env.VUE_APP_CONSOLE_V2_URL,
  enableConsoleV2Redirect:
    process.env.VUE_APP_ENABLE_CONSOLE_V2_REDIRECT === 'true',
  env: process.env.VUE_APP_ENV || 'local',
  nodesUrl: process.env.VUE_APP_NODES_URL,
  bitPayEnabled: !!process.env.VUE_APP_BITPAY_ENABLED,
  minEntropy: 95,
  stripeKey: process.env.VUE_APP_STRIPE_KEY,
  gaId: process.env.VUE_APP_GA_ID || false,
  redditPixelId: process.env.VUE_APP_REDDIT_PIXEL_ID,
  twitterPixelId: process.env.VUE_APP_TWITTER_PIXEL_ID,
  sentryDsn: process.env.VUE_APP_SENTRY_DSN || null,
  minClusterCapacity: process.env.VUE_APP_MIN_CLUSTER_CAPACITY || 2,
  maxClusterCapacity: process.env.VUE_APP_MAX_CLUSTER_CAPACITY || 10
}

export default config
